import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Switch Biológico',
    desc: 'La ciencia del sueño de tu bebé. Por qué fallan las estrategias aleatorias.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Santuario del Sueño',
    desc: 'Oscuridad, ruido blanco, temperatura. El ambiente que hace que el sueño ocurra solo.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Reloj Maestro',
    desc: 'Ventanas de Sueño Dinámicas por edad. El timing que lo cambia todo.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Autonomía Gradual',
    desc: 'Cómo enseñarle a dormirse solo, de forma respetuosa. Sin llanto controlado.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — El Manual de Crisis',
    desc: 'Protocolo para las noches más difíciles. Regresiones, dentición, viajes. Sabés exactamente qué hacer.'
  }];
  const includes = ['Protocolo listo para aplicar esa noche', 'Tabla de ventanas por edad', 'Señales de cansancio real', 'Checklist de validación', 'Bitácora de seguimiento', 'FAQ completo'];
  return <section className="pt-4 md:pt-6 pb-8 md:pb-12 px-4 bg-navy-800/30" data-id="element-222">
      <div className="max-w-5xl mx-auto" data-id="element-223">
        <FadeIn data-id="element-224">
          <div className="text-center mb-10" data-id="element-225">
            <div className="inline-block bg-gold-500/10 text-gold-400 px-4 py-1 rounded-full text-xs font-bold tracking-wider mb-3 border border-gold-500/20" data-id="element-226">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2" data-id="element-227">
              🏆 MEGAPACK NOCHES DE PAZ
            </h2>
            <p className="text-base text-gray-400" data-id="element-228">
              5 Tomos + 5 Bonos — 0 a 36 meses
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-16" data-id="element-229">
            <div className="space-y-4" data-id="element-230">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-800 p-5 rounded-xl border border-navy-700 hover:border-gold-500/30 transition-colors pt-[20px] pb-[20px] mt-[10px] mb-[10px]" data-id="element-231">
                  <div className="flex items-start" data-id="element-232">
                    <span className="text-3xl mr-4" data-id="element-233">{tomo.icon}</span>
                    <div data-id="element-234">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-235">
                        {tomo.title}
                      </h3>
                      <p className="text-gray-400" data-id="element-236">{tomo.desc}</p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="relative" data-id="element-237">
              <div className="absolute inset-0 bg-gold-500/5 blur-[50px] rounded-full" data-id="element-238"></div>
            </div>
          </div>

          <div className="bg-navy-900 border border-navy-700 rounded-2xl p-8 md:p-10 pt-[0px] pb-[0px]" data-id="element-239">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-center text-white mt-[12px] mb-[12px]" data-id="element-240">
              Cada tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-241">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-3 bg-navy-800/50 p-4 rounded-lg" data-id="element-242">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-243" />
                  <span className="text-gray-200 font-medium" data-id="element-244">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};